<template>
  <v-container fluid>
<!--    <v-select-->
<!--      v-model="event"-->
<!--      :items="evenementsSelectItems"-->
<!--      :no-data-text="$t('No results')"-->
<!--      :label="$t('Evenement')"-->
<!--      item-text="nom"-->
<!--      item-value="evenement[nom]"-->
<!--      chips-->
<!--      close-->
<!--      @click:close="chips = false"-->
<!--    >-->
<!--    </v-select>-->
     <v-select
      v-model="categorie"
      :items="categoriePartenaireSelectItems"
      :no-data-text="$t('No results')"
      :label="$t('Catégorie')"
      item-text="nom"
      item-value="categorie[nom]"
      chips
      close
      @click:close="chips = false"
    >
    </v-select>
  </v-container>
</template>

<script>
import has from "lodash/has";
import isEmpty from "lodash/isEmpty";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  name: 'PartenaireFilter',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      event: null,
      categorie:null,
    };
  },
 mounted() {
    this.evenementsGetSelectItems();
    this.categoriePartenaireGetSelectItems();
  },
  watch: {
    'event': function() {
      this.$emit("input", { "evenement.nom": this.event });
    },
    'categorie': function() {
      this.$emit("input", { "categorie.nom": this.categorie });
    },
    value: function() {
      if(isEmpty(this.value)){
        this.event=null;
        this.categorie=null;
      }
    }
  },
  computed: {
    ...mapFields("evenement", {
      evenementsSelectItems: "selectItems"
    }),
    ...mapFields("categoriePartenaire", {
      categoriePartenaireSelectItems: "selectItems"
    }),
    // eslint-disable-next-line
    item() {
      let data = this.initialValues || this.value;
      return data;
    }
  },
  methods: {
    ...mapActions({
      evenementsGetSelectItems: "evenement/fetchSelectItems",
      categoriePartenaireGetSelectItems: "categoriePartenaire/fetchSelectItems"
    })
  }
};
</script>
